import { useEffect, useRef, useState } from "react";

export default function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const debounceRef = useRef(0);

    useEffect(() => {
        if (value !== debouncedValue) {
            window.clearTimeout(debounceRef.current);
            debounceRef.current = window.setTimeout(setDebouncedValue, delay, value);
        }
    }, [debouncedValue, delay, value]);

    return debouncedValue;
}
